<label [for]="id" [ngClass]="['control-label', _labelClass]">Parc&nbsp;{{ _mandatory? '*' : '' }}:</label>
<div [ngClass]="_fieldClass">
	<extended-filterable-select
		[id]="id"
		[list]="parcs"
		[inputClass]="'form-control'"
		[labelGetter]="getParcLabel"
		[disabled]="disabled"
		[selectedItem]="selectedParc"
		(selectedItemChange)="onSelectedParcChange($event)"
		>
	</extended-filterable-select>
</div>